import { render, staticRenderFns } from "./RequestUnlock.vue?vue&type=template&id=9456907a"
import script from "./RequestUnlock.vue?vue&type=script&lang=ts"
export * from "./RequestUnlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports